import React from 'react';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';
import { CategoryTile } from '@/components/marketplace/CategoryTile';
import { useGenresCatalog } from '@/hooks/useGenresCatalog';

const GenresPage: React.FC = () => {
  const { data, isLoading, error } = useGenresCatalog({ limit: 20 });
  const items = data?.items || [];

  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <main className="flex-1 pt-24 pb-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-10 text-center">All Genres</h1>

          {error && (
            <div className="text-center text-sm text-red-500 mb-6">Failed to load genres.</div>
          )}

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6">
            {(isLoading ? Array.from({ length: 20 }) : items).map((g: any, idx: number) => (
              <CategoryTile
                key={g?.slug || idx}
                title={g?.name || '…'}
                icon={undefined}
                altText={`${g?.name || ''} light sequences`}
                href={g ? `/sequences/genre/${g.slug}` : '#'}
                className="relative"
              >
                <span className="absolute top-2 right-2 bg-primary text-primary-foreground text-xs px-2 py-1 rounded-full shadow-sm">
                  {g?.count ?? '—'} Sequences
                </span>
              </CategoryTile>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default GenresPage;